import { Injectable } from '@angular/core';
import { DynamicGiftDto, GiftClaimCheckResponse, GiftClaimResponse } from '@nova/types';
import { Observable } from 'rxjs';

import { UrlService } from 'app/core/http/url.service';
import { GameServerGateway } from 'app/student/game-section/services/gateways/game-server-gateway';

@Injectable({
  providedIn: 'root'
})
export class DynamicGiftsService {
  private readonly BASE_URL = 'dynamic-gifts';

  public constructor(
    private readonly urlService: UrlService,
    private readonly gameServerGateway: GameServerGateway
  ) {}

  public getGiftInfo(giftId: string): Observable<DynamicGiftDto | null> {
    const url = this.urlService.buildGameServerApiUrl(this.BASE_URL, 'info');
    return this.gameServerGateway.get<DynamicGiftDto | null>(url, { giftId });
  }

  public checkClaim(giftIds: string[]): Observable<GiftClaimCheckResponse> {
    const url = this.urlService.buildGameServerApiUrl(this.BASE_URL, 'check-claim');
    return this.gameServerGateway.get<GiftClaimCheckResponse>(url, { giftIds: giftIds.join(',') });
  }

  public claimGift(giftId: string): Observable<GiftClaimResponse> {
    const url = this.urlService.buildGameServerApiUrl(this.BASE_URL, 'claim');
    return this.gameServerGateway.post<GiftClaimResponse>(url, { giftId });
  }
}
